import React, { useState, useEffect } from "react";

export default function SplashScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    // Start fade out after 1.5 seconds
    const fadeTimer = setTimeout(() => {
      setIsFading(true);
    }, 1500);

    // Complete and unmount after 2 seconds
    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      if (onComplete) onComplete();
    }, 2000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-white transition-opacity duration-500 ${
        isFading ? "opacity-0" : "opacity-100"
      }`}
      data-testid="splash-screen"
    >
      {/* Logo with subtle pulse animation */}
      <div className="animate-[fadeInUp_0.6s_ease-out] relative">
        <img
          src="https://customer-assets-rejwkqb3.emergentagent.net/wingman/ec88479e-de0b-4b07-83a2-d0fc0e0593e3/attachments/a0930ce5021847efb76339185d8cd461_image.bin"
          alt="BQL Leads"
          className="h-28 sm:h-36 w-auto animate-[pulse_2s_ease-in-out_infinite]"
          onError={(e) => { e.target.src = "/bql-logo.png"; }}
        />
      </div>

      {/* App Name */}
      <h1 
        className="mt-6 text-2xl sm:text-3xl font-bold text-[#1e3a5f] animate-[fadeInUp_0.6s_ease-out_0.2s_both]"
      >
        BQL Leads
      </h1>

      {/* Tagline with gold accent */}
      <p 
        className="mt-2 text-sm sm:text-base text-[#d4a853] font-medium animate-[fadeInUp_0.6s_ease-out_0.4s_both]"
      >
        Where Quality Leads Begin
      </p>

      {/* Loading spinner - subtle gold dots */}
      <div className="mt-8 animate-[fadeInUp_0.6s_ease-out_0.6s_both]">
        <div className="flex gap-2">
          <div className="w-2.5 h-2.5 bg-[#d4a853] rounded-full animate-[bounce_1s_infinite_0ms]"></div>
          <div className="w-2.5 h-2.5 bg-[#d4a853] rounded-full animate-[bounce_1s_infinite_150ms]"></div>
          <div className="w-2.5 h-2.5 bg-[#d4a853] rounded-full animate-[bounce_1s_infinite_300ms]"></div>
        </div>
      </div>

      {/* Custom keyframes styles */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
            transform: scale(1);
          }
          50% {
            opacity: 0.9;
            transform: scale(1.02);
          }
        }
      `}</style>
    </div>
  );
}
